import { render } from "./UserFollowSettingsModal.vue?vue&type=template&id=7a011a37"
import script from "./UserFollowSettingsModal.vue?vue&type=script&lang=js"
export * from "./UserFollowSettingsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__